<template>
    <a  href="javascript:void(0)"
         class="text-primary m-r-10"
         id="InfoOpenModalGps"
         data-bs-toggle="modal"
         data-bs-target="#exampleModal5"
         style="display: none;"
         >
         <span class="fa fa-pencil" style="font-size: 1.6em"></span>
         </a>
      <div class="form-div" style="margin-bottom: 10px">
        <div class="col-md-12 col-sm-12 col-xs-12 p-0" v-show="list.TablaDetalle.length == 0">
            <div class="drop-area"  id="dropAreaDrag">
                <i style="margin-top: 30px; color: #1fa71f !important;" class="fa fa-file-excel-o fa-4x"></i>
                <h2>Suelta aqui el archivo o seleccionalo</h2>
                <button @click="$refs.refInputLogo1.click()">Seleccionar archivo</button>
                <input type="file" @change="readExcel($event)" name="" id="input-file" ref="refInputLogo1" accept=".xlsx, .xls, .xlsm" hidden multiple style="visibility: hidden;" />
            </div>
            <div id="preview"></div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 p-0" v-show="list.TablaDetalle.length > 0">
            <h4 style="text-align: center;  color: #61a239;">Operaciones Gps</h4>
          <div class="  col-md-12 col-sm-12 col-xs-12 p-l-0 p-r-0 m-b-10 paginate-padding" style="overflow-x: auto">
          <table class=" table table-responsive table-hover table-bordered custom-table">
            <thead>
              <tr>
                <th>NUMERO VIAJE</th>
                <th>CONDUCTOR</th>
                <th>PLACA</th>
                <th>SUPERVISOR</th>
                <th>FECHA GEN. VIAJE</th>
                <th style="background-color: rgb(142 29 157) !important;">LUGAR INICIO</th>
                <th style="background-color: rgb(142 29 157) !important;">FECHA PARTIDA</th>
                <th style="background-color: rgb(142 29 157) !important;">LLEGADA A MINA</th>
                <th style="background-color: rgb(142 29 157) !important;">INICIO CARGA</th>
                <th style="background-color: rgb(142 29 157) !important;">TERMINO CARGA</th>
                <th style="background-color: rgb(142 29 157) !important;">SALIDA PUNTO CARGA</th>
                <th style="background-color: rgb(142 29 157) !important;">LLEGADA COCHERA</th>
                <th style="background-color: rgb(142 29 157) !important;">SALIDA DE COCHERA</th>
                <th style="background-color: rgb(142 29 157) !important;">LLEGADA ALMACEN</th>
                <th style="background-color: rgb(142 29 157) !important;">INICIO DESCARGA</th>
                <th style="background-color: rgb(142 29 157) !important;">TERMINO DESCARGA</th>
                <th style="background-color: rgb(142 29 157) !important;">SALIDA PUNTO DESCARGA</th>
                <th style="background-color: rgb(142 29 157) !important;">FIN TRANSITO</th>
                <th style="background-color: rgb(142 29 157) !important;">PUNTO FINAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, key) in list.TablaDetalle" :key="key + 1"
                v-show=" (pag - 1) * NUM_RESULTS <= key && pag * NUM_RESULTS > key " >
                <td class="text-left">{{ item.NUMERO_VIAJE }}</td>
                <td class="text-left">{{ item.CONDUCTOR }}</td>
                <td class="text-left">{{ item.PLACA }}</td>
                <td class="text-left">{{ item.SUPERVISOR }}</td>
                <td class="text-left">{{ item.FECHA_GENERAVIAJE }}</td>
                <td class="text-left">{{ item.LUGAR_INICIO }}</td>
                <td class="text-left">{{ item.FECHA_PARTIDA }}</td>
                <td class="text-left">{{ item.LLEGADA_MINA }}</td>
                <td class="text-left">{{ item.INICIO_CARGA }}</td>
                <td class="text-left">{{ item.TERMINO_CARGA}}</td>
                <td class="text-left">{{ item.SALIDAPUNTO_CARGA }}</td>
                <td class="text-left">{{ item.LLEGADA_COCHERA }}</td>
                <td class="text-left">{{ item.SALIDA_COCHERA  }}</td>
                <td class="text-left">{{ item.LLEGADA_ALMACEN }}</td>
                <td class="text-left">{{ item.INICIO_DESCARGA }}</td>
                <td class="text-left">{{ item.TERMINO_DESCARGA }}</td>
                <td class="text-left">{{ item.SALIDAPUNTO_DESCARGA }}</td>
                <td class="text-left">{{ item.FIN_TRANSITO }}</td>
                <td class="text-left">{{ item.PUNTO_FINAL }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 p-0" style="margin-top: 10px !important">
          <nav aria-label="Page navigation" class="text-center">
            <ul class="pagination text-center pull-right">
              <li>
                <a  href="#" aria-label="Previous" v-show="pag != 1"  @click.prevent="pag -= 1" style="padding: 0px 0px 0px 0px">
                  <span aria-hidden="true">
                    <button class="btn btn-info" style="height: 25px; line-height: 10px; color: #344767">
                      <i class="fa fa-angle-double-left"></i>
                    </button>
                  </span>
                </a>
              </li>
              <li>
                <a href="#" aria-label="Next" v-show="(pag * NUM_RESULTS) / list.TablaDetalle.length < 1" @click.prevent="pag += 1" style="padding: 0px 10px 0px 5px">
                  <span aria-hidden="true">
                    <button class="btn btn-info" style="height: 25px; line-height: 10px; color: #344767" >
                      <i class="fa fa-angle-double-right"></i>
                    </button>
                  </span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 p-0" style="margin-top: 10px !important; text-align: right;">
          <button @click="limpiarData()"   class="btn btn-danger" style="margin-right: 3px !important" id="IdLimpDtaGps">
               <span style="margin-right: 5px"><i class="fa fa-close"></i></span>Limpiar Data
          </button>
          <button @click="register()"   class="btn btn-info" style="margin-right: 3px !important">
               <span style="margin-right: 5px"><i class="fa fa-save"></i></span>Grabar Data
          </button>
        </div>
        </div>
      </div>
  
      <div
      class="modal fade"
      id="exampleModal5"
      tabindex="-1"
      data-bs-backdrop="static"
      aria-labelledby="exampleModalLabel5"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel5">
              Observaciones Encontradas
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="form-div col-md-12 col-sm-12 col-xs-12 p-0">
              <div class="  col-md-12 col-sm-12 col-xs-12 p-l-0 p-r-0 m-b-10 paginate-padding" style="overflow-x: auto">
            <table class=" table table-responsive table-hover table-bordered custom-table">
              <thead>
                <tr>
                  <th>FILA</th>
                  <th>OBSERVACIÓN</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in list.popUp.table" :key="key + 1">
                  <td class="text-left">{{item.fila}}</td>
                  <td class="text-left">{{item.errorMessage}}</td>
                </tr>
              </tbody>
            </table>
          </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="close" type="button" class="btn btn-danger" data-bs-dismiss="modal" id="closeModalPrueba">
              <i class="fa fa-close" style="margin-right: 5px"></i>Cerrar
            </button>
          </div>
        </div>
      </div>
      </div>
  
  </template>
  
  <script>
  import * as XLSX from 'xlsx'
  import moment from "moment";
  import { APP } from "../../Content/base";
  
  export default {
      name:"AddExcelGps",
      el: "#AddExcelGps",
      data() {
      return {
           filtro: {},
           list: {
             TablaDetalle:[],
             popUp:{
              table:[]
             }
           },
           vselect: {},
  
           NUM_RESULTS: 10, // Numero de resultados por página
           pag: 1, // Página inicial
        };
       },
   async mounted() {
      let _this = this;
      document.addEventListener("dragover", function (event) {
       event.preventDefault();
       document.getElementById('dropAreaDrag').classList.add('active');
      });
  
      document.addEventListener("dragleave", function (event) {
        if (event.target.className == "dropAreaDrag") {
         event.target.style.border = "";
        }
      });
  
      document.addEventListener("drop", async function (event) {
         event.preventDefault();
         await _this.readExcel(event, 1);
         document.getElementById('dropAreaDrag').classList.remove('active');
    
      });
      document.addEventListener("dropAreaDrag", function (event) {
         if (event.target.className == "droptarget") {
           event.target.style.border = "3px dotted red";
         }
      });
    },
    methods: {
      readExcel: async function (e,t) {
        var file = null;
           if(t == 1)
            file = e.dataTransfer.files[0];
           else
            file = e.target.files[0];
            //const file = e.target.files[0];
            const promise = new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.readAsArrayBuffer(file);
                fileReader.onload = async (e) => {
                   const bufferArray = e.target.result;
                   const wb = XLSX.read(bufferArray, { type: "buffer" });
                   const wsname = wb.SheetNames[0];
                   const ws = wb.Sheets[wsname];
                   const data = XLSX.utils.sheet_to_json(ws);   
                  
                  // console.log(data);
                   await this.procesarDta(data);
  
                   document.getElementById('dropAreaDrag').classList.remove('active');
                   document.getElementById("input-file").value = "";
                  
                };
                fileReader.onerror = (error) => {
                    reject(error);
                };
            });
            promise.then((d) => {
                alert(d);
            });
      },
      procesarDta: async function(_data){
      let _this = this;

      //_this.list.TablaDetalle = _data;
  
      for (let i = 0; i < _data.length; i++) {
        _data[i].FECHA_GENERAVIAJE = await _this.ExcelDateToJSDate(_data[i].FECHA_GENERAVIAJE);
        
        //GPS
        _data[i].FECHA_PARTIDA = await _this.ExcelDateToJSDate(_data[i].FECHA_PARTIDA);
        _data[i].LLEGADA_MINA = await _this.ExcelDateToJSDate(_data[i].LLEGADA_MINA);
        _data[i].INICIO_CARGA = await _this.ExcelDateToJSDate(_data[i].INICIO_CARGA);
        _data[i].TERMINO_CARGA = await _this.ExcelDateToJSDate(_data[i].TERMINO_CARGA);
        _data[i].SALIDAPUNTO_CARGA = await _this.ExcelDateToJSDate(_data[i].SALIDAPUNTO_CARGA);
        _data[i].LLEGADA_COCHERA = await _this.ExcelDateToJSDate(_data[i].LLEGADA_COCHERA);
        _data[i].SALIDA_COCHERA = await _this.ExcelDateToJSDate(_data[i].SALIDA_COCHERA);
        _data[i].LLEGADA_ALMACEN = await _this.ExcelDateToJSDate(_data[i].LLEGADA_ALMACEN);
        _data[i].INICIO_DESCARGA = await _this.ExcelDateToJSDate(_data[i].INICIO_DESCARGA);
        _data[i].TERMINO_DESCARGA = await _this.ExcelDateToJSDate(_data[i].TERMINO_DESCARGA);
        _data[i].SALIDAPUNTO_DESCARGA = await _this.ExcelDateToJSDate(_data[i].SALIDAPUNTO_DESCARGA);
        _data[i].FIN_TRANSITO = await _this.ExcelDateToJSDate(_data[i].FIN_TRANSITO);
       
      }
  
      this.axios.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(localStorage.getItem("SessionToken"));
        var usuario = JSON.parse(localStorage.getItem("Usuario"));
  
        var request = {
              "IdEmpresa": 1,
              "Modulo": "GPS",
        };
      
      request.Detalle = [];
      _data.forEach((_item) => {
        request.Detalle.push({
                      "NUMERO_VIAJE": String(_item.NUMERO_VIAJE),
                      "CONDUCTOR": String(_item.CONDUCTOR),
                      "PLACA":  String(_item.PLACA),
                      "SUPERVISOR":  String(_item.SUPERVISOR),
                      "FECHA_GENERAVIAJE":  String(_item.FECHA_GENERAVIAJE),
                      "KM_INICIAL": '',
                      "KM_FINAL": '',
                      "KM_SCANNER": '',
                      "GLN_SCANNER": 0,
                      "GLN_ESTACION": 0,
                      "SERIE_VALE_MANUAL": '',
                      "NUMERO_VALE_MANUAL": 0,
                      "FECHA_VALE_MANUAL": '',
                      "SERIE_VALE_JELAF": '',
                      "NUMERO_VALE_JELAF": 0,
                      "FECHA_VALE_JELAF": '',
                      "LITROS_UREA": 0,
                      "FECHAVALE_UREAJELAF": '',
                      "SERIEVALE_UREAJELAF": '',
                      "NUMEROVALE_UREAJELAF":  0,
                      "SERIEVALE_UREAMANUAL": '',
                      "NUMEROVALE_UREAMANUAL": 0,
                      "LUGAR_INICIO": String(_item.LUGAR_INICIO),
                      "FECHA_PARTIDA": String(_item.FECHA_PARTIDA),
                      "LLEGADA_MINA": String(_item.LLEGADA_MINA),
                      "INICIO_CARGA":String(_item.INICIO_CARGA),
                      "TERMINO_CARGA": String(_item.TERMINO_CARGA),
                      "SALIDAPUNTO_CARGA": String(_item.SALIDAPUNTO_CARGA),
                      "LLEGADA_COCHERA": String(_item.LLEGADA_COCHERA),
                      "SALIDA_COCHERA": String(_item.SALIDA_COCHERA),
                      "LLEGADA_ALMACEN": String(_item.LLEGADA_ALMACEN),
                      "INICIO_DESCARGA": String(_item.INICIO_DESCARGA),
                      "TERMINO_DESCARGA": String(_item.TERMINO_DESCARGA),
                      "SALIDAPUNTO_DESCARGA": String(_item.SALIDAPUNTO_DESCARGA),
                      "FIN_TRANSITO": String(_item.FIN_TRANSITO),
                      "PUNTO_FINAL": String(_item.PUNTO_FINAL),
                      "OPERACION": '',
                      "RUTA": '',
                      "DESTINO": '',
                      "TIPO_VIAJE": '',
                      "Fecha_Entrega": '',
                      "Tipo_REGISTRO": '',
                      "Registro_GUIA_RT": '',
                      "Fecha_Carga_CLIENTE": '',
                      "GuiaRemision_Cliente": '',
                      "GuiaRemision_Wari": '',
                      "PesoBruto_MinaTN": 0,
                      "PesoNeto_MinaTN": 0,
                      "PesoBruto_AlmacenTN": 0,
                      "PrecioStand_ByUS": 0,
                      "NUEVA_SALIDA": 0,
                      "OBSERVACIONES": '',
                      "USR_RegisterApoyo":0,
                      "USR_RegisterGps":usuario ? parseInt(usuario.UsuarioId) : 0,
                      "USR_RegisterSuper":  0,
                    });
        });
      

      await this.axios
        .post("api/operaciones/admin/validateFormatoMasivo", request)
        .then(async (res) => {
          if (res.data.EsCorrecto) {
          
            if(res.data.Valor.length>0){
               _this.list.popUp.table = res.data.Valor;
               document.getElementById('InfoOpenModalGps').click();
            }else{
              _this.list.TablaDetalle = _data;
            }
      
      
          } else {
            APP.msg.error(this.$toast, res.data.Mensaje);
          }
        })
        .catch((error) => {
          APP.msg.error( this.$toast, "Token expirado Inicie session..!!" + error);
          localStorage.clear();
          this.$store.state.isLogeado = false;
          this.$router.push("/");
        }); 
      },
      ExcelDateToJSDate: async function(date) {
       var newdate = new Date(Math.round((date - 25569)*86400*1000));
       var ss =  moment(newdate).add(1, 'days');
       return moment(ss,"YYYY-MM-DD").format('DD/MM/YYYY');
      },
      limpiarData: function(){
        let _this = this;
        _this.list.TablaDetalle = [];
      },
      register: async function () {
        let _this = this;
  
            this.axios.defaults.headers.common["Authorization"] =
              "Bearer " + JSON.parse(localStorage.getItem("SessionToken"));
  
            var usuario = JSON.parse(localStorage.getItem("Usuario"));
  
            var request = {
              "IdEmpresa": 1,
              "Modulo": "GPS",
            };
  
            request.Detalle = [];
               _this.list.TablaDetalle.forEach((_item) => {
                    request.Detalle.push({
                      "NUMERO_VIAJE": String(_item.NUMERO_VIAJE),
                      "CONDUCTOR": String(_item.CONDUCTOR),
                      "PLACA":  String(_item.PLACA),
                      "SUPERVISOR":  String(_item.SUPERVISOR),
                      "FECHA_GENERAVIAJE":  String(_item.FECHA_GENERAVIAJE),
                      "KM_INICIAL": '',
                      "KM_FINAL": '',
                      "KM_SCANNER": '',
                      "GLN_SCANNER": 0,
                      "GLN_ESTACION": 0,
                      "SERIE_VALE_MANUAL": '',
                      "NUMERO_VALE_MANUAL": 0,
                      "FECHA_VALE_MANUAL": '',
                      "SERIE_VALE_JELAF": '',
                      "NUMERO_VALE_JELAF": 0,
                      "FECHA_VALE_JELAF": '',
                      "LITROS_UREA": 0,
                      "FECHAVALE_UREAJELAF": '',
                      "SERIEVALE_UREAJELAF": '',
                      "NUMEROVALE_UREAJELAF":  0,
                      "SERIEVALE_UREAMANUAL": '',
                      "NUMEROVALE_UREAMANUAL": 0,
                      "LUGAR_INICIO": String(_item.LUGAR_INICIO),
                      "FECHA_PARTIDA": String(_item.FECHA_PARTIDA),
                      "LLEGADA_MINA": String(_item.LLEGADA_MINA),
                      "INICIO_CARGA":String(_item.INICIO_CARGA),
                      "TERMINO_CARGA": String(_item.TERMINO_CARGA),
                      "SALIDAPUNTO_CARGA": String(_item.SALIDAPUNTO_CARGA),
                      "LLEGADA_COCHERA": String(_item.LLEGADA_COCHERA),
                      "SALIDA_COCHERA": String(_item.SALIDA_COCHERA),
                      "LLEGADA_ALMACEN": String(_item.LLEGADA_ALMACEN),
                      "INICIO_DESCARGA": String(_item.INICIO_DESCARGA),
                      "TERMINO_DESCARGA": String(_item.TERMINO_DESCARGA),
                      "SALIDAPUNTO_DESCARGA": String(_item.SALIDAPUNTO_DESCARGA),
                      "FIN_TRANSITO": String(_item.FIN_TRANSITO),
                      "PUNTO_FINAL": String(_item.PUNTO_FINAL),
                      "OPERACION": '',
                      "RUTA": '',
                      "DESTINO": '',
                      "TIPO_VIAJE": '',
                      "Fecha_Entrega": '',
                      "Tipo_REGISTRO": '',
                      "Registro_GUIA_RT": '',
                      "Fecha_Carga_CLIENTE": '',
                      "GuiaRemision_Cliente": '',
                      "GuiaRemision_Wari": '',
                      "PesoBruto_MinaTN": 0,
                      "PesoNeto_MinaTN": 0,
                      "PesoBruto_AlmacenTN": 0,
                      "PrecioStand_ByUS": 0,
                      "NUEVA_SALIDA": 0,
                      "OBSERVACIONES": '',
                      "USR_RegisterApoyo":0,
                      "USR_RegisterGps":usuario ? parseInt(usuario.UsuarioId) : 0,
                      "USR_RegisterSuper":  0,
                    });
              });
  
            await this.axios
              .post("api/operaciones/admin/RegistroOperacionesComplete", request)
              .then(async (res) => {
                if (res.data.EsCorrecto) {
                
                   if(res.data.Estado)
                   {
                    APP.msg.success(this.$toast, res.data.Mensaje);
                    _this.list.TablaDetalle = [];
                   }
                   else
                   {
                    APP.msg.warning(this.$toast,  res.data.Mensaje);
                   }
                } else {
                  APP.msg.error(this.$toast, res.data.Mensaje);
                }
              })
              .catch((error) => {
                APP.msg.error( this.$toast, "Token expirado Inicie session..!!" + error);
                localStorage.clear();
                this.$store.state.isLogeado = false;
                this.$router.push("/");
              });
        
      },
      close: function(){
        let _this = this;
        _this.list.popUp.table = [];
      },
  
  
    },
    }
  </script>
  
  <style scoped>
  
  </style>